// Dependencies
import React from 'react';

// Utils
import classNames from 'classnames';

import { Box, Text } from '@nerdwallet/currency';

import ControlPanelAccordion from './control-panel-accordion';
import FirstPanel from './first-panel';
import useControlPanelToggle from './hooks/use-control-panel-toggle';
import SecondPanel from './second-panel';

import styles from './control-panel.module.less';

const FORM_NAME = 'controlPanel';

type ControlPanelProps = {
  enableTracking?: boolean;
  toggleTitle?: string;
};

const yourDetailsPanel = {
  header: 'Your details',
  children: <FirstPanel />,
};

const moreOptionsPanel = {
  header: 'More Options',
  children: <SecondPanel />,
};

const accordionItems = [yourDetailsPanel, moreOptionsPanel];

/**
 * Rent Vs Buy Calculator - Control Panel view
 */
const ControlPanel = ({
  toggleTitle,
  enableTracking,
}: ControlPanelProps): JSX.Element => {
  const { isOpen, toggleControlPanel } = useControlPanelToggle({
    enableTracking,
    formName: FORM_NAME,
    fieldName: 'controlPanel',
  });

  return (
    <React.Fragment>
      <Box
        className={classNames(styles.controlPanelWrapper, {
          [styles.controlPanelOpen]: isOpen,
        })}
      >
        <Box className={styles.controlPanel}>
          <Box className={styles.closeIcon} onClick={toggleControlPanel} />
          <ControlPanelAccordion items={accordionItems} />
        </Box>
      </Box>
      {toggleTitle && (
        <Box
          className={classNames(styles.editIcon, { [styles.hidden]: isOpen })}
          onClick={toggleControlPanel}
        >
          <Text size="small">{toggleTitle}</Text>
        </Box>
      )}
    </React.Fragment>
  );
};

export default ControlPanel;
